module.exports = __webpack_public_path__ + "img/successIcon.553dc8b2.png";